/**
 * Form submit and control wiring for modals.
 */
import { closeCloseTimeModal, closeEstimateModal } from '../../modules/ui';
import type { ModalHandlerDeps } from './types';

export function setupFormSubmitHandlers(deps: ModalHandlerDeps): void {
  const { els } = deps;

  if (els.estimateForm) {
    els.estimateForm.addEventListener('submit', (e: Event) => {
      e.preventDefault();
      deps.commitEstimateEditFromModal();
    });
  }

  if (els.closeTimeForm) {
    els.closeTimeForm.addEventListener('submit', (e: Event) => {
      e.preventDefault();
      deps.commitCloseTimeEdit();
    });
  }

  const biddingToggle = document.getElementById('estimate-bidding-toggle');
  const bidAmountField = document.getElementById('estimate-bid-amount-field');
  if (biddingToggle instanceof HTMLInputElement && bidAmountField) {
    biddingToggle.addEventListener('change', () => {
      bidAmountField.hidden = !biddingToggle.checked;
    });
  }

  if (els.closeTimeClear) {
    els.closeTimeClear.addEventListener('click', () => {
      deps.clearCloseTimeEdit();
    });
  }

  if (els.closeTimeCancel) {
    els.closeTimeCancel.addEventListener('click', () => {
      closeCloseTimeModal();
    });
  }

  if (els.closeEstimateModal) {
    els.closeEstimateModal.addEventListener('click', () => {
      closeEstimateModal();
    });
  }
}
